const namaHari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const namaBulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", 
                   "Agustus", "September", "Oktober", "November", "Desember"];

export default { 
  showMessageBox(that, message, title, variant) {
    that.$bvModal
    .msgBoxOk(message, {
      title: title,
      size: "sm",
      buttonSize: "sm",
      okVariant: variant,
      headerClass: "p-2 border-bottom-0",
      footerClass: "p-2 border-top-0",
      centered: true
    })
    .then(value => {
      that.temp = value;
    })
    .catch(err => {
      that.temp = err;
    });
  }, 
  formatDayID(today) {
    if(!today) {
      today = new Date()
    }
    var text = '';
    text += namaHari[today.getDay()] + ", ";
    text += today.getDate() + " ";
    text += namaBulan[today.getMonth()] + " ";
    text += today.getFullYear();

    return text;
  }, 
  formatDateTimeID(dateStr) {
    var date = dateStr ? new Date(dateStr) : new Date();
    var text = '';
    text += namaHari[date.getDay()] + ", ";
    text += date.getDate() + " ";
    text += namaBulan[date.getMonth()] + " ";
    text += date.getFullYear() + " - ";
    text += ('0' + date.getHours()).slice(-2) + ":";
    text += ('0' + date.getMinutes()).slice(-2);

    return text;
  }, 
  formatDateTime(dateStr) {
    var date = dateStr ? new Date(dateStr) : new Date();
    var text = '';
    text += date.getFullYear() + "-";
    text += ('0' + (date.getMonth() + 1)).slice(-2) + "-";
    text += ('0' + date.getDate()).slice(-2) + ", ";
    text += ('0' + date.getHours()).slice(-2) + ":";
    text += ('0' + date.getMinutes()).slice(-2);

    return text;
  }, 
  formatDate(dateStr) {
    var date = dateStr ? new Date(dateStr) : new Date();
    var text = '';
    text += date.getFullYear() + "-";
    text += ('0' + (date.getMonth() + 1)).slice(-2) + "-";
    text += ('0' + date.getDate()).slice(-2);

    return text;
  }, 
  formatDateA(dateStr) {
    var date = dateStr.split("/");
    var text = ''
    text += date[2] + "-"
    text += date[0] + "-"
    text += date[1]
    return text;
  }, 
  formatDateB(dateStr) {
    var date = dateStr.split("-");
    var text = ''
    text += date[1] + "/"
    text += date[2] + "/"
    text += date[0]
    return text;
  }, 
  formatCurrency(data) {
    return data.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }, 
};